import $ from 'jquery'
import Parallax from 'rellax'

function parallaxInit () {
  const $parallax = $('.parallax')
  if ($parallax.length) {
    const p = new Parallax('.parallax')
  };
}

$(document).ready(function () {
  parallaxInit()
})
